<template>
  <div class='Box'>
    <el-card class="box-card">
      <el-form :model="queryParams" size="medium" label-width="100px" class="mt35">
        <el-row :gutter="35">

          <el-col :xs="24" :sm="12" :md="8" :lg="7" :xl="6" class="mb20">
            <el-form-item label="小说名称">
              <el-input v-model="queryParams.name" @change="search" placeholder="请输入小说名称" clearable></el-input>
            </el-form-item>
          </el-col>

          <el-col :xs="24" :sm="12" :md="8" :lg="7" :xl="6" class="mb20">
            <div class="btn_left">
              <el-button type="primary" size="medium" @click="search">查询</el-button>
              <el-button size="medium" @click="addNoNe">重置</el-button>
            </div>
          </el-col>

        </el-row>
      </el-form>
      <div class="div_buttom">
        <el-button size="medium" @click="addNoNe">刷新列表</el-button>
      </div>
      <el-table ref="multipleTable" :data="tableData" tooltip-effect="dark" style="width: 100%" size="medium"
                :header-cell-style="{ textAlign: 'center', background: '#f5f7fa' }"
                :cell-style="{ textAlign: 'center' }"
                @selection-change="handleSelectionChange" border v-loading="loading" :element-loading-text="loadingText">
        <el-table-column label="ID" width="80">
          <template slot-scope="scope">{{ scope.row.product_id }}</template>
        </el-table-column>
        <el-table-column prop="name" label="封面" width="120">
          <template slot-scope="scope">
            <el-image style="width: 80px; height: 80px" :src="scope.row.cover" :preview-src-list="[scope.row.cover]"
                      fit="cover">
            </el-image>
          </template>
        </el-table-column>
        <el-table-column prop="name" label="小说名称" width="150">
          <template slot-scope="scope">
            <!-- <el-link type="primary" @click="AddVideo(scope.row)">{{ scope.row.novel_name }}</el-link> -->
             <el-link type="primary">{{ scope.row.novel_name }}</el-link>
          </template>
        </el-table-column>
        <el-table-column prop="name" label="章节总数">
          <template slot-scope="scope">{{ scope.row.novel_chapter_total }}章</template>
        </el-table-column>
        <el-table-column prop="name" label="小说状态">
          <template slot-scope="scope">
            <span v-if="scope.row.product_visible==0">下架</span>
            <span v-if="scope.row.product_visible==1">上架</span>
            <span v-if="scope.row.product_visible==2">入库</span>

          </template>
        </el-table-column>
        <el-table-column prop="name" label="上传进度">
          <template slot-scope="scope">
            {{ scope.row.schedule }}
          </template>
        </el-table-column>
        <el-table-column prop="name" label="上传状态">
          <template slot-scope="scope">
            <!-- <el-tag type="danger" v-if="scope.row.upload_status==1">
              上传中
            </el-tag>
            <el-tag type="success" v-else-if="scope.row.upload_status==2">
              上传成功
            </el-tag>
           
            <el-tag type="warning" v-else-if="scope.row.upload_status==3">
              上传失败
            </el-tag> -->
            <!-- <el-tag type="info" v-else>
              {{ scope.row.upload_status_text }}
            </el-tag> -->
            {{ scope.row.upload_status_text }}
          </template>
        </el-table-column>
        <el-table-column prop="name" label="审核状态">
          <template slot-scope="scope">
            <div @click="hangeStatus(scope.row)" style="cursor: pointer;">
              <el-tag type="danger" v-if="scope.row.audit_status==3">审核拒绝</el-tag>
              <el-tag type="success" v-else-if="scope.row.audit_status==2">审核通过</el-tag>
              <el-tag type="info" v-else-if="scope.row.audit_status==0">未审核</el-tag>
              <el-tag type="warning" v-else-if="scope.row.audit_status==1">审核中</el-tag>
              <el-tag type="info" v-else>暂无状态</el-tag>
              <!-- {{ scope.row.audit_status_text }} -->
            </div>
          </template>
        </el-table-column>
        <el-table-column fixed="right" label="操作" width="150">
          <template slot-scope="scope">
            <div style="display: flex; justify-content: center; align-items: center; gap: 5px;"> <!-- 使用 Flexbox 居中 -->
              <el-button
                  type="text"
                  size="medium"
                  @click="addsynchronous(scope.row.product_id)"
                  :disabled="scope.row.audit_status == 1 || scope.row.upload_status == 1 || scope.row.product_visible == 1"
              >同步
              </el-button>

              <div v-if="scope.row.upload_status == 2">
                <el-button v-if="scope.row.audit_status == 0 || scope.row.audit_status == null" type="text" size="medium"
                           @click="Submission(scope.row.product_id)">提审
                </el-button>
                <el-button v-else type="text" size="medium"
                           @click="AgainSubmission(scope.row.product_id)" :disabled="scope.row.audit_status == 1 || scope.row.product_visible == 1">重审
                </el-button>
              </div>

              <div v-if="scope.row.upload_status == 1 || scope.row.upload_status == 3 || scope.row.upload_status == null">
                <el-tooltip class="item" effect="dark" content="请上传小说" placement="top">
                  <el-button v-if="scope.row.audit_status == 0 || scope.row.audit_status == null" type="text" size="medium" disabled>提审</el-button>
                  <el-button v-else type="text" size="medium" disabled>重审</el-button>
                </el-tooltip>
              </div>
            </div>
          </template>
        </el-table-column>

      </el-table>
      <pagination v-show="total > 0" :total="total" :page.sync="queryParams.pageNo" :limit.sync="queryParams.pageSize"
                  @pagination="getList"/>

      <ShortPlayInfo v-if="ShortPlayInfoFlag" :ShortPlayInfoFlag="ShortPlayInfoFlag" @NoneDlog="NoneDlog" @AddOk="AddOk"
                     :editID="editID">
      </ShortPlayInfo>

      <VideoPlay v-if="dialogTableVisible" :dialogTableVisible="dialogTableVisible" :videoObj="videoPlayObj"
                 @videoNone="videoNone">
      </VideoPlay>
      <StatusList v-if="dialogstatusVisible" :dialogstatusVisible="dialogstatusVisible" :statusId="statusId" :statusName="statusName"
                @StatusNone="StatusNone">
      </StatusList>
    </el-card>
  </div>
</template>

<script>
import {WorksListAPI} from '@/api/Works/WorksList';
import {processErrors} from "@/utils/errorHandler";
import ShortPlayInfo from "./component/ShortPlayInfo.vue"
import VideoPlay from '@/components/VideoPlay/index'
import StatusList from "./component/StatusList.vue"
import {UpdateAPI} from "@/api/Update/Update";

export default {
  components: {
    ShortPlayInfo,
    VideoPlay,
    StatusList
  },
  data() {
    return {
      queryParams: {
        pageNo: 1,
        pageSize: 10,
        name: "",
        origin_name: "",
        book_name: "",
        cp_name: "",
        category_id: "",
        status: "",
        visible: "",
        is_open_zrll: "",
        cansee: "",
        source: ""
      },
      appidList: [],
      page: {
        pageNo: 1,
        pageSize: 999,
        type: "4"
      },
      tableData: [],
      multipleSelection: [],
      editID: "",
      // 总条数
      total: 0,
      ShortPlayInfoFlag: false,
      uploadVideoFlag: false,
      dialogTableVisible: false,
      dialogstatusVisible:false,
      videoObj: "",
      statusId:"",
      statusName:"",
      loading: true,
      currentTime: this.formatTime(new Date()),
      loadingText:"加载中...",
      videoPlayObj: {},
    };
  },
  created() {
    this.getList()
  },
  methods: {

    addsynchronous(novel_id) {
      this.$confirm('确定同步该作品吗 ?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
          .then(() => {
            let api = UpdateAPI()
            let params = {
              novel_id: novel_id
            }
            api.getWechat(params).then(res => {
              if (res.code == 0) {
                this.$message.success('同步成功');
                this.getList();
              } else {
                processErrors(res);
              }
            })
          })
          .catch(() => {
            this.$message({
              message: '取消同步',
              type: 'info' // 使用 'info' 类型表示提示信息
            });
          });
    },

    StatusNone(){
      this.dialogstatusVisible=false
    },
    hangeStatus(row){
      this.statusId = row.product_id
      this.statusName=row.product_name
      this.dialogstatusVisible = true
    },
    Submission(product_id) {
      this.$confirm('确定要提审吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.loading = true
        this.loadingText = "正在提审中..."
        let api = WorksListAPI()
        api.getReview({novel_id: product_id}).then(res => {
          if (res.code == 0) {
            this.getList()
            this.loading = false
            this.loadingText = "加载中..."
          } else {
            processErrors(res);
            this.loading = false
            this.loadingText = "加载中..."
          }
        })
      }).catch(() => {
        // 用户点击取消时，不做任何操作
        this.$message({
          message: '提审操作已取消',
          type: 'info',
        });
      });
    },

    AgainSubmission(product_id) {
      this.$confirm('确定要重审吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.loading = true
        this.loadingText = "正在重审中..."
        let api = WorksListAPI()
        api.againReview({novel_id: product_id}).then(res => {
          if (res.code == 0) {
            this.getList()
            this.loading = false
            this.loadingText = "加载中..."
          } else {
            processErrors(res);
            this.loading = false
            this.loadingText = "加载中..."
          }
        })
      }).catch(() => {
        // 用户点击取消时，不做任何操作
        this.$message({
          message: '重审操作已取消',
          type: 'info',
        });
      });
    },

    formatTime(date) {
      const year = date.getFullYear();
      const month = (date.getMonth() + 1).toString().padStart(2, '0');
      const day = date.getDate().toString().padStart(2, '0');
      const hour = date.getHours().toString().padStart(2, '0');
      const minute = date.getMinutes().toString().padStart(2, '0');
      const second = date.getSeconds().toString().padStart(2, '0');
      return `${year}-${month}-${day} ${hour}:${minute}:${second}`;
    },

    addput(name) {
      if (navigator.clipboard && window.isSecureContext) {
        navigator.clipboard
            .writeText(name)
            .then(() => {
              // 复制成功
              this.$message.success('复制成功！');
            })
            .catch((err) => {
              // 复制失败
              this.$message.error('复制失败！');
            });
      } else {
        // 浏览器不支持剪贴板API
        this.$message.error('当前浏览器不支持复制到剪贴板功能！');
      }
    },

    getList() {
      this.loading = true;
      this.tableData = []
      let api = WorksListAPI()
      api.getCataloglist(this.queryParams).then(res => {
        if (res.code == 0) {
          this.tableData = res.data.data
          this.total = res.data.totalCount
        } else {
          processErrors(res);
        }
        this.loading = false;
      })
    },
    // 打开搜索
    addSearch() {
      if (this.SearchFlag == false) {
        this.SearchFlag = true
      } else {
        this.SearchFlag = false
      }
    },
    handleSelectionChange(val) {
      this.multipleSelection = val
    },
    // 搜索
    search() {
      this.getList()
    },
    // 重置列表
    addNoNe() {
      this.queryParams = {
        pageNo: 1,
        pageSize: 10,

      }
      this.getList()
    },
    addList() {
      this.editID = ""
      this.ShortPlayInfoFlag = true
    },
    NoneDlog() {
      this.ShortPlayInfoFlag = false
    },
    AddOk() {
      this.editID = ""
      this.ShortPlayInfoFlag = false
      this.getList()
    },
    addEdit(row) {
      this.editID = row.id
      this.ShortPlayInfoFlag = true
    },

    AddVideo(row) {
      this.videoObj = row
      this.videoPlayObj.id = row.product_id
      this.videoPlayObj.name = row.product_name
      this.videoPlayObj.episode_total = row.episode_total
      this.dialogTableVisible = true
    },
    videoNone() {
      this.dialogTableVisible = false
    }

  },

  mounted() {

  },
}
</script>
<style lang='scss' scoped>
.Box {
  & ::v-deep el-card__body {

    padding: 0 !important;

  }
}

.description-span {
  display: -webkit-box;
  /* 对于 Webkit 浏览器的兼容性 */
  -webkit-line-clamp: 3;
  /* 显示的行数 */
  -webkit-box-orient: vertical;
  /* 设置或检索伸缩盒对象的子元素的排列方式 */
  overflow: hidden;
  text-overflow: ellipsis;
  //white-space: nowrap;
}

.el-card__body {
  padding: 0px !important;
}

.btn_left {
  margin-left: 100px;
}

.div_buttom {
  width: 100%;
  display: flex;
  margin-bottom: 20px;
}

.Coimage {
  width: 50px;
  height: 50px;
}

.item {
  margin: 4px;
}
</style>